import React from 'react';
import './style.scss';
import logo from '../../../assets/images/LogoWhite.svg';
const BusinessCardHeader = () => {
  return (
    <div className="BusinessContainer">
      <img src={logo} alt="logo" className='logoWhite' />
    </div>
  );
};

export default BusinessCardHeader;
